import {
  isMobile
} from '~js/utils'
import {
  convertIndexFromUrlToArray,
  krpanoHelpers
} from '~js/helpers'
import router from '@/router/index'

export default class PanoramasManager {
  constructor ({ dispatch, commit, state, rootState }) {
    this.dispatch = dispatch
    this.commit = commit
    this.state = state
    this.rootState = rootState
  }

  completeCallback () {
    this.dispatch('setAppReady', true)
    this.dispatch('setKrpanoActive', true)
    this.dispatch('closeProgress')
    window.setTimeout(() => {
      if (window.krpanoObj) {
        if (isMobile()) {
          this.dispatch('initGyroFromIframe')
        }
        window.setTimeout(() => {
          if (krpanoHelpers) {
            krpanoHelpers.adjustKrpanoRendering(window.krpanoObj)
          }
        }, 2500)
      }
    })
  }

  noPanoramasHandler () {
    this.commit('SET_PANORAMAS', [])
    this.commit('SET_PANORAMA', {})
    this.dispatch('closeProgress')
    this.dispatch('setPanoramasNotFound', true)
    this.completeCallback()
  }

  panoramaMarkersReadyHandler (panoramas) {
    let startIndex = convertIndexFromUrlToArray(this.rootState.route.query.index, panoramas.length)
    this.commit('SET_PANORAMAS', panoramas || [])
    // for pilot teleport, use query.panorama instead of query.index
    if (this.rootState.route.query.panorama) {
      const findIndex = panoramas.findIndex(panorama => panorama.objectId === this.rootState.route.query.panorama)
      if (findIndex !== -1 && findIndex !== startIndex) {
        startIndex = findIndex
      }
      const query = Object.assign({}, this.rootState.route.query)
      delete query.panorama
      query.index = startIndex + 1
      router.replace({ query })
    }
    this.dispatch('setPanorama', (panoramas && panoramas.length) ? panoramas[startIndex] : {})
    this.dispatch('addProgressCount', 10)
    if (panoramas && panoramas.length) {
      const initPanorama = panoramas[startIndex]
      panoramas.forEach(panorama => {
        // Assets preloading is removed, we have preview images now
        this.previewImageLoadFinished(panoramas, initPanorama)
      })
    }
  }

  previewImageLoadFinished (panoramas, initPanorama) {
    this.dispatch('addProgressCount', 2)
    if (this.rootState.progress.progressValue >= panoramas.length * 2 + 10) {
      if (initPanorama.cubemapReady) {
        this.completeCallback()
      } else {
        this.dispatch('setProgressMax', this.rootState.progress.progressMax + 1)
        setTimeout(() => {
          this.dispatch('addProgressCount', 1)
          this.completeCallback()
        })
      }
    }
  }
}
